import { TranslateService } from "@ngx-translate/core";
import { Inject, Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { CheckUtils, EncryptStorageEvent, LanguageModel, LanguagesEvent, logger, OdConfig, OrganizationDetailsProviderEvent } from "../..";
var LanguageProvider = /** @class */ (function () {
    function LanguageProvider(config, _translate, _model, _events) {
        this.config = config;
        this._translate = _translate;
        this._model = _model;
        this._events = _events;
        this._translate.use(this.config.defaultLanguage);
        this.setup();
        this.bind();
    }
    LanguageProvider.prototype.setup = function () {
        var _this = this;
        this._translate.use(this.config.defaultLanguage);
        this._languageHandler = function () {
            _this._model.clear(false, true);
            if (_this.has(_this.config.languages, _this.config.defaultLanguage)) {
                _this._model.setLanguages(_this.config.languages);
                _this._model.setDefaultLanguage(_this.config.defaultLanguage);
                _this._model.load();
            }
            else {
                logger.info("error: init language");
            }
        };
        this._customLanguageHandler = function (res) {
            if (res.langKey != null) {
                if (res.customLangFileId != null && res.langKey === "cus") {
                    _this._translate.currentLoader.setCusFileId(res.customLangFileId);
                    _this._translate.currentLoader.getTranslation(res.langKey);
                    _this._translate.use(res.langKey);
                }
                else {
                    _this._translate.use(res.langKey);
                }
            }
        };
    };
    LanguageProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, this._languageHandler);
        this._events.subscribe(LanguagesEvent.LOADED, function () {
            if (CheckUtils.isEmpty(_this._model.language))
                _this.model.setLanguage(_this.getLanguage(_this._model.language), true);
            _this.onChangeLanguage(_this.model.language);
        });
        this._events.subscribe(LanguagesEvent.LANGUAGE_CHANGED, function (language) { return _this.onChangeLanguage(_this.getLanguage(language)); });
        this._events.subscribe(OrganizationDetailsProviderEvent.READY, this._customLanguageHandler);
    };
    Object.defineProperty(LanguageProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    LanguageProvider.prototype.onChangeLanguage = function (language) {
        if (CheckUtils.isEmpty(this._translate.getDefaultLang()))
            this._translate.setDefaultLang(language);
        this._translate.use(language);
    };
    LanguageProvider.prototype.getLanguage = function (language) {
        return (CheckUtils.isEmpty(language)) ?
            ((CheckUtils.isEmpty(this._translate.getBrowserLang())) ?
                this._translate.getBrowserLang() : this.config.defaultLanguage) :
            language;
    };
    LanguageProvider.prototype.has = function (languages, language) {
        return !(CheckUtils.isEmpty(languages) || languages.find(function (l) { return l == language; }) == null);
    };
    LanguageProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LanguageProvider.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
        { type: TranslateService, },
        { type: LanguageModel, },
        { type: Events, },
    ]; };
    return LanguageProvider;
}());
export { LanguageProvider };
//# sourceMappingURL=language-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/language/language-provider.js
// module id = 362
// module chunks = 14